export default __webpack_public_path__ + "static/media/oops-img.f6f60832.png";